// import {SESSION_PROJECT_CHANGE} from "../../../../gd/bus/bus-event-type"
import ApiProject from "../../../../gd/api/project"
import ProjectSession from "../../../../model2/project/project-session"

export const changeProjectIcon = (project: ProjectSession, icon: string)=> {

    // project.projectIcon = icon
    // project.save()

    // update session and rerender menu
    // project.projectIcon = icon
    // gd.bus.triggerEvent(SESSION_PROJECT_CHANGE, project.id)

    // close popover
    gd.layout.popovers.closeAll()

    // save changes... and prevent reRender on the current browser tab
    ApiProject.updateNew(project.id, {
        projectIcon: icon
    }, {
        processSessionResponse: false
    })
}
